<template>
  <div>
    <v-container class="pa-0">
      <v-row>
        <v-col cols="6">
          <v-btn @click="handleClickAdd" small
            ><v-icon size="12" class="mr-2 btn-icon">fas fa-plus</v-icon>New
            Group</v-btn
          >
        </v-col>
        <v-col cols="6" class="text-right">
          <!-- <v-btn @click="handleClickDelete" small
            ><v-icon size="12" class="mr-2 btn-icon">far fa-trash-alt</v-icon
            >Delete</v-btn
          > -->
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <Loader
            v-if="loading"
            text="Loading groups"
            size="small"
            class="mt-5"
          ></Loader>

          <v-list v-if="!loading" class="pa-0 listing">
            <v-list-item-group v-model="selected" mandatory>
              <template>
                <div v-if="!groups || !groups.length" class="pa-2">
                  No groups found
                </div>
                <div v-if="groups">
                  <div v-for="(group, index) in groups" :key="index">
                    <v-list-item @click="handleClickSelect(group)">
                      <template>
                        <v-list-item-content>
                          <v-list-item-title>{{
                            group.name
                          }}</v-list-item-title>

                          <v-list-item-subtitle
                            v-if="membersOnMapFeatureUnlocked"
                          >
                            <v-switch
                              v-model="group.showMembersOnMap"
                              @click="handleClickShowMembersOnMap(group)"
                              class="ml-2 my-2 show-members-switch"
                              dense
                              hide-details="auto"
                              label="SHOW MEMBERS ON MAP"
                              return-object
                            ></v-switch>
                          </v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-icon>
                          <v-menu open-on-click offset-x right rounded="lg">
                            <template v-slot:activator="{ on: menu }">
                              <v-icon
                                v-on="menu"
                                class="pull-right mr-2 mt-1 hyp-options-icon"
                                size="14"
                                >fas fa-ellipsis-v</v-icon
                              >
                            </template>

                            <v-list-item-group>
                              <v-list class="pa-0">
                                <v-list-item @click="handleClickRename(group)">
                                  <v-list-item-title>
                                    <v-icon size="16" class="mr-1"
                                      >fas fa-pencil-alt</v-icon
                                    >
                                    Rename group
                                  </v-list-item-title>
                                </v-list-item>
                              </v-list>
                              <v-list class="pa-0">
                                <v-list-item @click="handleClickCopy(group)">
                                  <v-list-item-title>
                                    <v-icon size="16" class="mr-1"
                                      >far fa-clone</v-icon
                                    >
                                    Copy group
                                  </v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-list-item-group>
                          </v-menu>
                        </v-list-item-icon>
                      </template>
                    </v-list-item>

                    <v-divider
                      v-if="index < groups.length - 1"
                      :key="index"
                    ></v-divider>
                  </div>
                </div>
              </template>
            </v-list-item-group>
          </v-list>
        </v-col>
      </v-row>
    </v-container>

    <ConfirmationPopup
      :show="confirmationShow"
      :title="confirmationTitle"
      :text="confirmationText"
      :has-text-input="confirmationHasTextInput"
      :text-input-placeholder="confirmationInputPlaceholder"
      :input-text-value="confirmationInputTextValue"
      :buttonCancel="confirmationBtnCancel"
      :buttonAction="confirmationBtnAction"
    ></ConfirmationPopup>
  </div>
</template>

<script>
import lodashOrderBy from "lodash/orderBy";
import lodashCloneDeep from "lodash/cloneDeep";
import lodashFind from "lodash/find";

import {
  getGroups,
  saveGroup,
  copyGroup,
  deleteGroup,
} from "@/services/communication/communication.service";

import { pageTrackerLogger } from "@/common/pageTracker";
import { EVENT_ACTIONS, EVENT_CATEGORIES } from "@/common/constants/analytics";

const EMITTED_ACTIONS = {
  SELECTED: "selected",
  SHOW_MEMBERS: "show-members",
};

export default {
  name: "CommsGroupListing",
  components: {
    ConfirmationPopup: () => import("@/components/common/ConfirmationPopup"),
    Loader: () => import("@/components/common/Loader"),
  },
  props: {
    showMembersGroup: {
      type: Object,
    },
  },
  data: () => ({
    loading: false,
    selected: 0,
    groups: null,
    selectedGroup: null,
    confirmationShow: false,
    action: null,
  }),
  async mounted() {
    await this.getGroups();
  },
  computed: {
    membersOnMapFeatureUnlocked() {
      return this.featureUnlocked("mass-comm-members-on-map");
    },
    confirmationTitle() {
      if (this.action === "delete") {
        return "Delete group";
      } else if (this.action === "rename") {
        return "Rename group";
      } else if (this.action === "copy") {
        return "Copy group";
      }
      return "Add group";
    },
    confirmationText() {
      return this.action === "delete"
        ? `Are you sure you want to delete the group <br/><strong>${this.selectedGroup.name}</strong>?`
        : null;
    },
    confirmationHasTextInput() {
      return this.action !== "delete";
    },
    confirmationInputPlaceholder() {
      return "Enter group name";
    },
    confirmationInputTextValue() {
      if (this.selectedGroup && this.selectedGroup.name) {
        if (this.action === "rename") {
          return this.selectedGroup.name;
        } else if (this.action === "copy") {
          return `Copy of ${this.selectedGroup.name}`;
        }
      }
      return null;
    },
    confirmationBtnCancel() {
      return {
        text: "Cancel",
        onClickFnc: async () => {
          this.setConfirmationShow(false);
          if (this.groups && this.groups.length) {
            await this.setGroup(this.groups[this.selected]);
          }
        },
      };
    },
    confirmationBtnAction() {
      return {
        text: this.action === "delete" ? "Delete" : "Save",
        disabled: this.loading && this.action !== "delete",
        loader: this.loading,
        onClickFnc: async (params) => {
          if (this.action === "delete") {
            await this.deleteGroup();
          } else if (this.action === "rename") {
            await this.renameGroup(params.textfield);
          } else if (this.action === "copy") {
            await this.copyGroup(params.textfield);
          } else {
            await this.addGroup(params.textfield);
          }
          this.setConfirmationShow(false);
        },
      };
    },
  },
  methods: {
    async getGroups(group) {
      this.loading = true;
      const groups = await getGroups();
      this.groups = lodashOrderBy(groups, ["name"]);
      if (this.groups && this.groups.length) {
        let grp = this.groups[0];
        if (group) {
          if (typeof group === "object") {
            grp = group;
          } else if (typeof group === "string") {
            const g = lodashFind(this.groups, { groupId: group });
            if (g) {
              grp = g;
            }
          }
        }
        await this.setGroup(grp);
      }
      if (this.showMembersGroup && this.showMembersGroup.showMembersOnMap) {
        const g = lodashFind(this.groups, {
          groupId: this.showMembersGroup.groupId,
        });
        if (g) {
          this.$set(g, "showMembersOnMap", true);
        }
      }

      this.loading = false;
    },
    async setGroup(group) {
      if (group) {
        this.selectedGroup = group;
        this.$emit(EMITTED_ACTIONS.SELECTED, this.selectedGroup);
      }
    },
    async addGroup(groupName) {
      this.loading = true;
      await saveGroup({ group: { name: groupName } });
      await this.getGroups();
      this.loading = false;
      this.handlePageTrackerEvent(
        EVENT_CATEGORIES.mass_communication,
        EVENT_ACTIONS.clicked,
        "Create a Group"
      );
    },
    async deleteGroup() {
      this.loading = true;
      await deleteGroup({ group: this.selectedGroup });
      await this.getGroups();
      this.loading = false;
      this.handlePageTrackerEvent(
        EVENT_CATEGORIES.mass_communication,
        EVENT_ACTIONS.clicked,
        "Delete a Group"
      );
    },
    async renameGroup(groupName) {
      this.loading = true;
      const group = lodashCloneDeep(this.selectedGroup);
      group.name = groupName;
      const result = await saveGroup({ group });
      if (result) {
        await this.getGroups(group);
      }
      this.loading = false;
      this.handlePageTrackerEvent(
        EVENT_CATEGORIES.mass_communication,
        EVENT_ACTIONS.clicked,
        "Rename a Group"
      );
    },
    async copyGroup(groupName) {
      this.loading = true;
      const groupCopy = await copyGroup({
        groupId: this.selectedGroup.groupId,
        name: groupName,
      });
      await this.getGroups(groupCopy);
      this.loading = false;
      this.handlePageTrackerEvent(
        EVENT_CATEGORIES.mass_communication,
        EVENT_ACTIONS.clicked,
        "Copy a Group"
      );
    },
    async handleClickSelect(group) {
      await this.setGroup(group);
    },
    async handleClickAdd() {
      this.selectedGroup = null;
      this.action = "add";
      this.setConfirmationShow(true);
    },
    async handleClickRename(group) {
      this.selectedGroup = group;
      this.action = "rename";
      this.setConfirmationShow(true);
    },
    async handleClickCopy(group) {
      this.selectedGroup = group;
      this.action = "copy";
      this.setConfirmationShow(true);
    },
    async handleClickDelete() {
      if (this.selectedGroup) {
        this.action = "delete";
        this.setConfirmationShow(true);
      }
    },
    handleClickShowMembersOnMap(group) {
      this.groups.forEach((g) => {
        if (g.groupId !== group.groupId) {
          this.$set(g, "showMembersOnMap", false);
        }
      });
      this.$emit(EMITTED_ACTIONS.SHOW_MEMBERS, group);
    },
    setConfirmationShow(value) {
      this.confirmationShow = value;
    },
    handlePageTrackerEvent(category, action, name) {
      let _paq = (window._paq = window._paq || []);
      _paq.push(["trackEvent", category, action, name]);
      pageTrackerLogger(
        "Page Tracker Event " +
          category +
          " " +
          action +
          " " +
          name +
          " logged."
      );
    },
  },
  beforeDestroy() {
    this.selected = 0;
    this.groups = null;
    this.selectedGroup = null;
    this.confirmationShow = false;
  },
};
</script>

<style>
.show-members-switch .v-label {
  font-size: 12px !important;
}
</style>

<style scoped>
.item-icon {
  position: relative;
  left: 15px;
  top: 2px;
}
.btn-icon {
  position: relative;
  top: 1px;
}
.listing {
  height: 65vh;
  overflow-y: auto;
}
</style>
